import { z } from 'zod';
import { Id, Timestamp, VerticalKey } from './common.js';

export const Email = z.string().trim().toLowerCase().email().max(254);

/** Minimum password length (owner decision 2026-09-21: login is email + password only). */
export const PASSWORD_MIN = 10;
export const Password = z.string().min(PASSWORD_MIN).max(200);

export const LoginRequest = z.object({ email: Email, password: Password }).strict();
export type LoginRequest = z.infer<typeof LoginRequest>;

/** Membership role. Org-level admin rights come from Me.isAdmin (app_user.is_admin), not from this. */
export const Role = z.enum(['admin', 'member']);
export const Membership = z.object({
  verticalId: Id,
  verticalKey: VerticalKey,
  role: Role,
});
export type Membership = z.infer<typeof Membership>;

export const Me = z.object({
  id: Id,
  orgId: Id,
  email: Email,
  name: z.string().min(1),
  /** Org admin: may invite users and change memberships. */
  isAdmin: z.boolean(),
  memberships: z.array(Membership),
});
export type Me = z.infer<typeof Me>;

/** Session is an httpOnly cookie; body only carries the user + CSRF token. */
export const LoginResponse = z.object({ user: Me, csrfToken: z.string().min(16), expiresAt: Timestamp });
export type LoginResponse = z.infer<typeof LoginResponse>;

/** Accept an invite in one step: prove the emailed token and choose a password. The account becomes active. */
export const AcceptInviteRequest = z
  .object({ email: Email, token: z.string().min(20).max(200), password: Password })
  .strict();
export type AcceptInviteRequest = z.infer<typeof AcceptInviteRequest>;
